// extracted by mini-css-extract-plugin
export var ExternalLink = "cta-external-link-module--ExternalLink--49136";
export var ExternalLinkImageWrapper = "cta-external-link-module--ExternalLinkImageWrapper--4c325";
export var SideColumnText = "cta-external-link-module--SideColumnText--86a91";
export var SideColumnTitle = "cta-external-link-module--SideColumnTitle--9e591";
export var body = "cta-external-link-module--body--40068";